import React, { useMemo, Suspense } from 'react';
import { Box, Typography } from '@mui/material';
import { useUser } from '@client/hooks/use-user.hooks';
import { isAdmin } from '@shared/helpers/user.helpers';
import { DotLoader } from '@ui/DotLoader';

// because non-admins shouldn't get this page.
const LazyComponentsIndex = React.lazy(() =>
  import('./components/ComponentsIndex').then((m) => ({
    default: m.ComponentsIndex,
  })),
);

export const AdminComponents: React.FC = () => {
  const user = useUser();
  const disabled = useMemo(() => !user || !isAdmin(user), [user]);

  if (disabled) {
    return (
      <Box
        sx={{
          p: 4,
        }}
      >
        <Typography variant="h6">Not allowed</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100vh', overflow: 'hidden' }}>
      <Suspense
        fallback={
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              p: 4,
            }}
          >
            Loading components
            <DotLoader />
          </Typography>
        }
      >
        <LazyComponentsIndex />
      </Suspense>
    </Box>
  );
};
